/* Judge.me owns validation, identity confirmation, media uploads and submission. */
if (!customElements.get('product-review-form')) {
  customElements.define('product-review-form', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const status = this.querySelector('[data-review-status]');
      const open = async (event) => {
        event.preventDefault();
        if (this.opening) return;
        this.opening = true;
        status.textContent = 'Loading review form…';
        const selector = '[data-testid="write-review-button"], .jdgm-write-rev-link';
        let button;
        for (let attempt = 0; attempt < 40 && this.isConnected; attempt++) {
          button = this.querySelector(selector);
          if (button) break;
          await new Promise((resolve) => setTimeout(resolve, 250));
        }
        if (button) {
          status.textContent = '';
          button.click();
        } else {
          status.textContent = 'The review form could not load. Please refresh the page and try again.';
        }
        this.opening = false;
      };
      this.querySelector('[data-open-native-review]').addEventListener('click', open, { signal: this.controller.signal });
      document.querySelectorAll('.product-review-link').forEach((link) => {
        if (link.hash === '#' + this.id) {
          link.addEventListener('click', open, { signal: this.controller.signal });
        }
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
